<template>
  
  <div id="app">
    <!-- <seturl v-if="isSeturl"></seturl> -->
    <div style="width:100%;height:100vh;display:flex;" v-if="isLoginPage==false">
      <leftnav></leftnav>
      <div class="right-content">
        <pagehead></pagehead>
        <router-view />
      </div> 
    </div>
    <div v-else>
      <loginPage></loginPage>
    </div>
  </div>
</template>

<script>
import { login } from "./api/index.js";
import leftnav from "@/components/leftNav.vue";
import pagehead from "@/components/pagehead.vue";
import loginPage from "@/views/home/login.vue";
// import seturl from "@/views/home/seturl.vue";
export default {
  data() {
    return {
      isLoginPage:false,//是否登录页面
      isSeturl: true
    };
  },   
  name: "App", 
  components: {
    leftnav,
    pagehead,
    loginPage,
    // seturl,
  },
  methods: {
    bodyScale() {
      var devicewidth = document.documentElement.clientWidth;
      var scale = devicewidth / 1920; // 分母——设计稿的尺寸宽度
      // document.body.style.zoom = scale-0.07113;
      //页面尺寸放大
      document.body.style.zoom = scale;
      //解决zoom放大缩小导致echarts位置偏移问题
      let strScale = `scale(${scale})`;
      var obj = {
        zoom: 1 / scale,
        transform: strScale,
        transformOrigin: "0 0",
      };
      this.insertCss("canvas", obj);
    },
    insertCss(select, styles) {
      console.log(styles);
      if (document.styleSheets.length === 0) {
        //如果没有style标签,则创建一个style标签
        var style = document.createElement("style");
        document.head.appendChild(style);
      }
      var styleSheet = document.styleSheets[document.styleSheets.length - 1]; //如果有style 标签.则插入到最后一个style标签中
      var str = select + " {"; //插入的内容必须是字符串,所以得把obj转化为字符串
      for (var prop in styles) {
        str +=
          prop.replace(/([A-Z])/g, function (item) {
            //使用正则把大写字母替换成 '-小写字母'
            return "-" + item.toLowerCase();
          }) +
          ":" +
          styles[prop] +
          ";";
      }
      str += "}";
      styleSheet.insertRule(str, styleSheet.cssRules.length); //插入样式到最后一个style标签中的最后面
    },
  },
  created() {
    // const baseurl = localStorage.getItem('baseurl')
    // if (!baseurl || route.path == '/seturl') {
    //   this.isSeturl = true
    // } else {
    //   this.isSeturl = false
    // }
  },
  async mounted() {
    const route = this.$route.name;
    console.log('___route', route)
    if(route==null || route == 'login3' || route == 'login2'){
      this.isLoginPage=true;
    }else{
      this.isLoginPage=false;
    }
    window.onload = window.onresize = () => {
      this.bodyScale();
    };
  },
};
</script>
<style lang="scss">
html {
  overflow: hidden;
}
body {
  background-color: #f3f3f8;
}
#app {
  -webkit-font-smoothing: "antialiased";
  -moz-osx-font-smoothing: "grayscale";
  /* text-align: center; */
  height: 100%;
  width: 1920px;
  display: flex;
  background: #f3f3f8;
  position: relative;
}

@font-face {
  font-family: "lcdd";
  src: url("./assets/LcdD.ttf");
}

@font-face {
  font-family: "pmzd";
  src: url("./assets/pmzd.ttf");
}

@font-face {
  font-family: "bmzy";
  src: url("./assets/bmzy.ttf");
}

// ::-webkit-scrollbar {
// 	width: 8px;
// 	height: 16px;
// 	background-color: transparent;
// }

/*定义滚动条轨道内阴影+圆角*/

// ::-webkit-scrollbar-track {
// 	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
// 	border-radius: 10px;
// 	background-color: rgba(2, 28, 51, 0.7);
// }

// /*定义滑块内阴影+圆角*/
// ::-webkit-scrollbar-thumb {
// 	border-radius: 10px;
// 	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
// 	background-image: linear-gradient(#3de0cf, #3de0cf);
// }
.right-content {
  width: -webkit-fill-available;
}
</style>